import {SupplementalSalary} from '@app/core/models/supplementalSalary.model';
import {Pagination} from '@app/core/models/pagination.model';

export interface ISupplementalSalaryState {
	supplementalSalaries: SupplementalSalary[];
	selectedSupplementalSalary: SupplementalSalary;
	pagination: Pagination;
	isLoading: boolean;
}

export const initialSupplementalSalaryState: ISupplementalSalaryState = {
	supplementalSalaries: [],
	selectedSupplementalSalary: undefined,
	isLoading: false,
	pagination: undefined,
};
